import React from "react";
import ReactDOM from "react-dom/client";
import StoreTile from "../components/StoreTile.jsx";
import './frontend.css';
/*const observer = new MutationObserver(() => {
  document.querySelectorAll(".wp-block-bigsave-store-tile").forEach((div) => {
    const data = JSON.parse(div.querySelector("pre").innerText);
    div.innerHTML = ""; // Clear container before mounting React
    ReactDOM.createRoot(div).render(<StoreTile store={data} />);
  });
});
observer.observe(document.body, { childList: true, subtree: true });*/

const observer = new MutationObserver(() => {
  document.querySelectorAll(".wp-block-bigsave-store-tile").forEach((div) => {
    // Skip if already rendered
    if (div.__reactRendered) return;

    const raw = div.getAttribute("data-store");
    if (!raw) return;

    try {
      const data = JSON.parse(raw);
      ReactDOM.createRoot(div).render(<StoreTile store={data} />);
      div.__reactRendered = true; // mark so we don't re-render
    } catch (e) {
      console.error("Invalid store data", e);
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });